"use client";

import { c as _c } from "react/compiler-runtime";
import { AuthContext } from "@/components/auth/Auth";
import { useSeizeConnectContext } from "@/components/auth/SeizeConnectContext";
import type { ApiIdentity } from "@/generated/models/ApiIdentity";
import { useIdentity } from "@/hooks/useIdentity";
import { useParams, useRouter } from "next/navigation";
import { useContext, useEffect } from "react";
import UserPageDrops from "./UserPageDrops";
export default function UserPageBrainWrapper(t0) {
  const $ = _c(19);
  const {
    profile: initialProfile
  } = t0;
  const params = useParams();
  const router = useRouter();
  let t1;
  if ($[0] !== params?.user) {
    t1 = (params?.user as string)?.toLowerCase();
    $[0] = params?.user;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const user = t1;
  const {
    address
  } = useSeizeConnectContext();
  const {
    connectedProfile,
    activeProfileProxy,
    showWaves
  } = useContext(AuthContext);
  let t2;
  if ($[2] !== address || $[3] !== connectedProfile || $[4] !== router || $[5] !== showWaves || $[6] !== user) {
    t2 = () => {
      if (showWaves) {
        return;
      }
      if (connectedProfile || !address) {
        router.push(`/${user}/rep`);
      }
    };
    $[2] = address;
    $[3] = connectedProfile;
    $[4] = router;
    $[5] = showWaves;
    $[6] = user;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== activeProfileProxy || $[9] !== address || $[10] !== connectedProfile || $[11] !== showWaves) {
    t3 = [connectedProfile, activeProfileProxy, address, showWaves];
    $[8] = activeProfileProxy;
    $[9] = address;
    $[10] = connectedProfile;
    $[11] = showWaves;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  useEffect(t2, t3);
  let t4;
  if ($[13] !== initialProfile || $[14] !== user) {
    t4 = {
      handleOrWallet: user,
      initialProfile
    };
    $[13] = initialProfile;
    $[14] = user;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  const {
    profile
  } = useIdentity(t4);
  if (!showWaves) {
    let t5;
    if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <div className="tw-min-h-screen" />;
      $[16] = t5;
    } else {
      t5 = $[16];
    }
    return t5;
  }
  let t5;
  if ($[17] !== profile) {
    t5 = <UserPageDrops profile={profile} />;
    $[17] = profile;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  return t5;
}